import { ProductApiModel } from '../models/ProductModel';

const getNetQuantity = (product: ProductApiModel): number =>
  Math.max(0, product.quantityTotal - (product.quantityRefunded ?? 0));

export default getNetQuantity;
